import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ResetPasswordRequest } from '../../../models/user-profile/reset-password-request';
import { ResetPasswordResponse } from '../../../models/user-profile/reset-password-response';
import { UrlConstants } from '../../../constants/url.constants';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {

  private readonly httpClient = inject(HttpClient);

  public resetPasswordInit(token: string){
    const httpParams = new HttpParams().append('token', token);
    return this.httpClient.get<ResetPasswordResponse>(UrlConstants.CHANGE_PASSWORD_INIT, {params: httpParams})
  }

  public resetPassword(token: string, resetPassword: ResetPasswordRequest){
    const httpParams = new HttpParams().append('token', token);
    return this.httpClient.post<ResetPasswordResponse>(UrlConstants.CHANGE_PASSWORD, resetPassword, {params: httpParams});
  }
}
